// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/freezing-level.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/freezing-level/freezing-level-facts.js';
import g1 from '../lessons/meteorology/freezing-level/freezing-level.js';

mount([g0, g1]);
